export default __webpack_public_path__ + "media/images/menu-icon/internet-b898d8bae51de14904dd328afe23846c.png";